import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { Instrument, InstrumentGroup } from '@personal-area/global/accounts/models';

export const instrumentsURL = {
  groups: (timestamp: number) => `/assets/symbols/groups/groups.json?v=${timestamp}`,
  instruments: (type: string) => `/assets/symbols/accounts/${type}.json`
};

@Injectable()
export class InstrumentsApiService {

  constructor(
    private _http: HttpClient
  ) { }

  public getGroups(): Observable<InstrumentGroup[]> {
    return this._http.get<InstrumentGroup[]>(instrumentsURL.groups(Date.now()));
  }

  public getInstrumentsByAccountType(type: string): Observable<Instrument[]> {
    return this._http.get<Instrument[]>(instrumentsURL.instruments(type));
  }
}
